export default __webpack_public_path__ + "static/media/edit.inline.e8ce3483.svg";